//Login.js
import React from "react";
import { Form, Input, Button, message, Spin, Tooltip, Checkbox } from "antd";

import QRCode from 'qrcode.react';
import md5 from "js-md5";
import cookie from "react-cookies";

import Config from "../config/Config";
import Widget from "../widget/Widget";
import WidgetAjax from "../widget/WidgetAjax";
import WidgetModal from "../widget/WidgetModal";
import WidgetAES from '../widget/WidgetAES';

import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
let path = Config.getBasePath();
let application = Config.getApplication();
let baseRoutePath = Config.getBaseRoutePath();
React.Component.prototype.$md5 = md5;

class Login extends React.Component {
  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);
    sessionStorage.removeItem("_user_token_");
    sessionStorage.removeItem("UID");
    let urlParam = this.props.location.state;
    this.state = {
      leftList: [
        { title: '专业', tips: "找工作，上聘准准", icon: require("../img/pinzhunzhun/login/icon_zy.png") },
        { title: '优质', tips: "优质岗位，为您甄选", icon: require("../img/pinzhunzhun/login/icon_yz.png") },
        { title: '高效', tips: "更快更便捷找工作", icon: require("../img/pinzhunzhun/login/icon_gx.png") },
      ],
      switchType: 'pc',
      urlParam,
      qrImg: undefined,//二维码
      qrCodeLose: false,//二维码蒙层
      qrLoading: false,
      tabSwitch: 1,//注册登录页面切换 1 登录 2注册
      ticket: undefined,//二维码信息ID
      editRpasswordOptions: {
        title: "修改密码",
        confirm: "确定",
      },
      pwsTips: false,
      regular1: false, //密码校验规则
      regular2: false,
      regular3: false,
      customerPhone: Config.getCustomerPhone(),
      sourcePath: Config.getSourcePath(),
      licenseContent: Config.getLicenseContent(),
      loginSuccess: false // 防止登录成功后轮询回调触发
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab');
    const code = urlParams.get('code');
    const redirectURL = urlParams.get('redirectURL');
    if (redirectURL) {
      this.setState({ redirectURL });
    }
    Widget.loadClass();
    this.requirement();
    if (tab) {
      this.setState({ tabSwitch: tab });
      this.getGzhQrcode();
    }
    else if (code) {
      sessionStorage.setItem("_user_access_", code);
    }
    else {
      // 首次进入默认登录页: 拉取公众号二维码并启动扫码轮询
      this.getGzhQrcode();
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  requirement = () => {

    const onRequirement = (result, params) => {

      if (result.status === 0) {
        let password = result.password;

        let message = "密码中必须包含大小写字母、数字、特殊字符";

        let minLength = 10, maxLength = 20, complex = 2;

        if (password) {
          minLength = password.min_length;
          maxLength = password.max_length;

          complex = password.complex;


          switch (password.complex) {
            case 1:
            case "1":
              {
                message += "中的1项, "
                break;
              }
            case 2:
            case "2":
              {
                message += "中的2项, "
                break;
              }
            case 3:
            case "3":
              {
                message += "中的3项, "
                break;
              }
            case 4:
            case "4":
              {
                message += "中的4项, "
                break;
              }
            case 5:
            case "5":
              {
                message += "中的5项, "
                break;
              }
          }



          message += "长度至少" + minLength + "个字符，最多" + maxLength + "个字符!"
        }
        else {
          message = "密码中必须包含大小写字母、数字、特殊字符中的2项，长度至少8个字符，最多21个字符！"
        }


        this.setState({ requiredMessage: message, minLength: minLength, maxLength: maxLength, complex: complex });
      }
      else {

      }
    }

    WidgetAjax.ajax({ url: Config.getBasePath() + '/requirement', params: undefined, callback: onRequirement });
  }

  verificatePassword = (value) => {

    const { complex, minLength, maxLength } = this.state;

    // 1. 长度校验 
    if (value.length < minLength) {

      this.setState({ requiredMessage: '密码长度不能少于' + minLength + '个字符!' });

      return false;
    }
    if (value.length > maxLength) {

      this.setState({ requiredMessage: '密码长度不能多于' + maxLength + '个字符!' });

      return false;
    }

    // 2. 复杂度校验 
    let size = 0;
    let regex;
    regex = new RegExp('[A-Z]+');
    if (regex.test(value)) size++;

    regex = new RegExp('[a-z]+');
    if (regex.test(value)) size++;

    regex = new RegExp('[0-9]+');
    if (regex.test(value)) size++;

    regex = new RegExp('[.@$!%*#_~?&^]+');
    if (regex.test(value)) size++;

    if (size < complex) {

      this.setState({ requiredMessage: '密码中必须包含大写字母、小写字母、数字、特殊字符中' + complex + '项!' });

      return false;
    }
    return true;

  }



  /**
   * 获取二维码
   */
  getGzhQrcode = () => {
    const onGzhQrcode = async (res) => {
      if (res.status == 0) {
        if (res.result && res.result.result) {

          this.setState({ ticket: res.result.result });
        
          const onGethQrcode = (data) => {
          
            if (data && data.result && data.result.result) {
              this.setState({ qrImg: data.result.result });
              this.forLogin();//轮询是否扫码
            }

          }
          WidgetAjax.ajax({ url: path + "/weixin/qrcode", params: { ticket: res.result.result }, callback: onGethQrcode })
        }

      }
    }
    WidgetAjax.ajax({ url: path + "/weixin/login_ticket", params: { application }, callback: onGzhQrcode });


  }

  /**
   * 轮询二维码状态
   */
  forLogin = () => {
    let forIndex = 0;

    this.timer = setInterval(() => {
      this.gzhLogin();
      forIndex++;
      if (forIndex === 30) {  // 三分钟即 180 秒，每秒调用一次，所以这里是 180
        this.setState({ qrCodeLose: true })
        clearInterval(this.timer);
      }
    }, 2000);
  }

  /**
   * 状态查询
   */
  gzhLogin = () => {
    const { ticket, loginSuccess } = this.state; //UID
    console.log(loginSuccess,'loginSuccess--');
    
    if (loginSuccess) return; // 登录成功后不再处理回调
    let params = {
      username: application,
      secret: ticket
    }
    WidgetAjax.ajax({ url: path + "/login", params, callback: this.onLogin, });
  }



  /**
   * 登录
   * @param {} type 
   * @returns 
   */
  login(type) {

    let { username, password, messages, checked } = this.state;
    if (!checked) return message.info("请勾选协议");
    if (type) {
      this.setState({ qrLoading: true })
      // TODO 验证用户
      if (username === "") {
       
        return  message.info("账号不能为空");
      }

      if (password === "") {
       
        return  message.info("密码不能为空");
      }

      password = this.$md5("ES_6ps" + password + "_N3tM").toUpperCase();
      WidgetAjax.ajax({
        url: path + "/login",
        params: { username: 'cell|' + username + '|SP', secret: password },
        callback: this.onLogin,
      });
    }

    this.setState({ messages: undefined })
  }


  onLogin = (result, params) => {

    this.setState({ qrLoading: false })
    if (result.status === 0) {
      this.setState({ loginSuccess: true }); // 标记登录成功，阻止后续轮询回调处理
      clearInterval(this.timer);
      Widget.clearSessionStorage();
      sessionStorage.setItem("bulletin", true);
      sessionStorage.setItem("_user_token_", result.access);
      sessionStorage.setItem("_user_access_", result.access);
      this.getUserInfo();
      if (
        result.user_info !== undefined &&
        result.user_info.extensions !== undefined &&
        result.user_info.extensions.access !== undefined
      ) {
        localStorage.setItem(
          "access_token",
          result.user_info.extensions.access
        );

        sessionStorage.setItem("access_token", result.access);
      }

      Widget.removeSessionStorage("_left_node_activeKey_");
      Widget.removeSessionStorage("_left_node_openKey_");

      sessionStorage.setItem("_user_login_info_", JSON.stringify(result));
      cookie.save("_user_login_info_", result, { path: "/" });

    }
    else if (result.status == 3) { }
    else if (result.status == 11) {
      if (result.message.includes("未绑定用户")) {
        this.setState({ unregistered: true })
      }
    }
    else if (
      result.status === 30 ||
      result.password_update_requirement === "first_login"
    ) {
      message.info(result.message);
      this.editRpassworRef.open()
      return false;
    }
    else {
      if (result.message === '用户不可登录！') {
        clearInterval(this.timer);
        this.getGzhQrcode();
        this.setPwdRef.open();
      } else {
        clearInterval(this.timer);
        message.info(result.message);
        this.getGzhQrcode();
      }
    }
    this.setState({ messages: result.message });
  }

  getUserInfo = () => {
    const { redirectURL, urlParam } = this.state;
    const onInfo = (res) => {
      if (res.status === 0) {
        if (res.result && res.result.extensions) {
          sessionStorage.setItem("_user_info_", JSON.stringify(res.result));
        }
        if (redirectURL) {
          this.props.history.push({ pathname: redirectURL, state: urlParam });
        } else {
          const onInfo = (res) => {
            if (res.status == 0) {
              if (res.result && res.result?.RIC && res.result?.RIC > 0.3) {
                this.props.history.push({ pathname: "/home/homepage", state: { isLogin: true } });
              } else {
                this.props.history.push({ pathname: "/home/choiceExpect", state: { isLogin: true } });
              }
            }
          }

          WidgetAjax.ajax({ url: path + "/applicant/resume_info", params: {}, callback: onInfo })
          // this.props.history.push({ pathname: "/home/homepage", state: { isLogin: true } });
        }
      }
    }
    WidgetAjax.ajax({ url: path + "/info", callback: onInfo })
  }


  /**
  * 键盘事件捕获
  * @param {*} e
  */
  onKeyup = (e) => {
    if (e.keyCode === 13) {
      this.login('manual');
    }
  }

  onTabSwitch = () => {
    const { tabSwitch } = this.state;
    this.setState({ tabSwitch: tabSwitch == 1 ? 2 : 1, current: 0 })
    if (tabSwitch == 1) {
      clearInterval(this.timer);
    }
    else {
      this.getGzhQrcode();

    }

  }

  /**
   * 二维码刷新
   */
  refresh = async () => {
    await this.getGzhQrcode();
    this.setState({ qrCodeLose: false });
  }

  password = () => {
    let { new_password, old_password, username } = this.state;

    this.form.validateFields().then((value) => {

      this.state.editRpasswordOptions['isVisible'] = false;
      this.setState({ isVisible: true });
      // old_password = this.$md5("ES_6ps" + old_password + "_N3tM").toUpperCase();
      // new_password = this.$md5("ES_6ps" + new_password + "_N3tM").toUpperCase();

      // let params = {
      //   username,
      //   old_password: old_password,
      //   new_password: new_password
      // }
      let nonce = Widget.randomString(6, true);

      let oldPasswordEncryption = this.$md5("ES_6ps" + old_password + "_N3tM").toUpperCase();
      let newPasswordEncryption = WidgetAES.encryptPassword(new_password, nonce);
      let params = {
        username,
        old_password: oldPasswordEncryption,
        new_password: newPasswordEncryption + nonce
      }

      const onPassword = (result) => {
        if (result.status === 0) {
          message.success("密码修改成功！");
          this.editRpassworRef.onClose();
        } else {
          message.error("密码修改失败" + result.message);

        }
      }
      WidgetAjax.ajax({ url: Config.getBasePath() + '/update_password', params: params, callback: onPassword });

    })
  }

  validateCreditPassword = (rule, value, callback) => {

    if (value) {
      let regular1 = false, regular2 = false, regular3 = false
      // const passwordRegex1 = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{6,20}$/; // 密码正则表达式，6到20个字符，包含字母、符号和数字
      const passwordRegex2 = /^[A-Za-z0-9\d!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/; // 密码正则表达式，只包含字母、数字以及除空格外的标点符号
      const passwordRegex3 = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/; // 密码正则表达式，至少包含字母、数字和标点符号中的任意两种
      if (value.length > 6) //用户名 和 密码 不能一致
      {
        regular1 = true
      }
      if (passwordRegex2.test(value)) {
        regular2 = true
      }
      if (passwordRegex3.test(value)) {
        regular3 = true
      }
      if (regular1 && regular2 && regular3) {
        callback();
      }
      else {
        callback('密码格式不正确');
      }
      this.setState({ regular1, regular2, regular3 });

    } else {
      callback();
    }

  }

  handleCheckboxChange = (e) => {
    this.setState({ checked: e.target.checked });
  };

  switchChange = (value) => {
    if (value === 'qrCode') {
      this.getGzhQrcode();
    } else {
      clearInterval(this.timer);
    }
    this.setState({ switchType: value });
  }

  /**
   * switchType 注册1 找回密码2
   * setType:1 存在代表是新用户
   */
  setPwd = () => { 
    this.props.history.push({ pathname: "/register", state: { switchType: 2,setType:1} })
  }


  render() {
    let that = this;
    let { leftList, checked, switchType, qrImg, qrCodeLose, qrLoading, tabSwitch, messages, editRpasswordOptions, old_password, new_password, username,
      unregistered, licenseContent } = this.state;

    let layout = { labelCol: { span: 6 }, wrapperCol: { span: 16 } };

    return (
      <div className="slg-login" component-data="loginVersions2" >
        <Spin tip="正在登录..." spinning={qrLoading}>

          <div className="slg-login-bc">

            <div className="slg-login-body">
              <div className="slg-login-box">

                {/* 左侧 */}
                <div className="login-img-box">
                  <div className="login-left-box">
                    <div className="logo-liepin-box">
                      <img src={require("../img/pinzhunzhun/login/logo.svg")} />
                    </div>
                    <ul className="left-list-box">
                      {
                        leftList.map((item) => {
                          return <div className="login-left-list-item-box">
                            <div className="left-list-item-icon"><img src={item?.icon} /></div>
                            <div className="left-list-item-text-box">
                              <div className="item-text-title">{item?.title}</div>
                              <div className="item-text-subtitle">{item?.tips}</div>
                            </div>
                          </div>
                        })
                      }
                    </ul>
                  </div>
                </div>
                {/* 右侧 */}
                <div className="login-box">
                  <div className="teno-login-container">
                    <div className="role-title">我要找工作</div>
                    <div className="switch-type-btn-box">
                      <div className="teno-login-type-tabs-box"> {switchType === 'qrCode' ? null : '登录'}</div>
                      <div className="switch-type-mask-img-box">
                        {
                          switchType === 'qrCode' ?
                            <Tooltip placement="left" title={'手机号登录'} >
                              <img onClick={() => this.switchChange('pc')} src={require("../img/pinzhunzhun/login/icon-switch-pc.svg")} />
                            </Tooltip>
                            :
                            <Tooltip placement="left" title={'扫码登录'} >
                              <img onClick={() => this.switchChange('qrCode')} src={require("../img/pinzhunzhun/login/icon-switch-qrcode.svg")} />
                            </Tooltip>
                        }
                      </div>
                    </div>

                    {
                      switchType === 'qrCode' ?
                        < div className="login-qrcode-box" >       {/* 二维码*/}
                          <div className="QRCodeBox ">
                            <div className="sg-qr-expired-mask" style={{ display: qrCodeLose ? 'block' : 'none' }}>
                              <img className="sg-qr-expired-icon" alt="#" src={require("../img/qr-error.png")} />
                              <div className="sg-qr-expired-message">二维码已失效</div>
                              <a className="sg-qr-refresh" onClick={() => { this.refresh() }}>点击刷新</a>
                            </div>
                            {
                              qrImg ?
                                <img className={qrLoading ? "qrImg qrfuzzy" : "qrImg"} src={`data:image/png;base64, ${qrImg}`} alt="登录二维码" />
                                :

                                <div className="qrfuzzy qrImg"><QRCode value={'高校毕业生就业服务智能体平台'} size={180} /></div>
                            }
                          </div>
                          {
                            unregistered ?
                              <div className="unregistered_box">
                                <div>用户尚未注册</div>
                                <Button type="primary" onClick={() => { this.props.history.push("/register") }}>立即注册</Button>
                              </div>
                              : null
                          }

                        </div>
                        :
                        <div className="login-input-box">  {/* 账号登录 */}
                          <div onKeyUp={this.onKeyup} >
                            <Form >
                              <Form.Item label="" style={{ marginBottom: "24px", backgroundColor: "#fff" }}>
                                <Input size="large" placeholder="手机号" onChange={(e) => this.setState({ username: e.target.value })} />
                              </Form.Item>
                              <div className="form-item-control-input login-input-pwd">
                                <Form.Item label="" style={{ marginBottom: "0", backgroundColor: "#fff" }}>
                                  <Input.Password style={{ width: "276px" }} variant="borderless" size="large" placeholder="密码" type="password" onChange={(e) => this.setState({ password: e.target.value })} />
                                </Form.Item>
                                <span className="input-suffix" onClick={() => { this.props.history.push({ pathname: "/register", state: { switchType: 2 } }) }}>找回密码</span>
                              </div>

                              <div style={{ display: messages === '用户名或密码错误！' ? 'block' : 'none', color: 'red', textAlign: 'left' }}>{messages}</div>
                              <Form.Item
                                className="jtct"
                                name="check"
                                style={{ marginTop: "24px", marginBottom: "0" }}
                                rules={[
                                  {
                                    validator: (_, value) => {
                                      const { checked } = this.state
                                      if (checked) {
                                        return Promise.resolve()
                                      } else {
                                        return Promise.reject(new Error('请勾选协议'))
                                      }
                                    }
                                  },
                                ]}
                              >
                                <Checkbox checked={checked} onChange={this.handleCheckboxChange} />
                            <span className="sg-check">已阅读并同意
                                    <a onClick={(e) => { e.stopPropagation(); window.open(baseRoutePath + '/home/service-agreement', '_blank') }}>《聘准准用户服务协议》
                                    </a>及<a onClick={(e) => { e.stopPropagation(); window.open(baseRoutePath + '/home/privacy-policy', '_blank') }}>《个人信息保护政策》</a></span>
                              </Form.Item>
                              <Button type="primary" style={{ height: "44px" }} block size="large" onClick={() => this.login('manual')}> 登录</Button>
                            </Form>
                            <span style={{ display:'flex',marginTop:'24px' }} className="sg-check">没有聘准准账号？ <a onClick={() => { this.props.history.push("/register") }}>立即注册</a></span>
                          </div>
                        </div>
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>

        </Spin >

        <WidgetModal options={{ title: '温馨提示',width:'448px',isCancel:false,okText:'设置密码' }} onRef={ref => this.setPwdRef = ref} onOk={()=>this.setPwd()}>
         <div style={{paddingTop:'20px'}}>您已是系统用户，首次登录需设置密码</div> 
        </WidgetModal>


        <WidgetModal options={editRpasswordOptions} isHide={true} onRef={ref => this.editRpassworRef = ref} onOk={() => this.password()}>
          <Form ref={ref => this.form = ref} {...layout} name="basic">
            <Form.Item label="账号" name="username">
              <Input defaultValue={username} disabled ></Input>
            </Form.Item>
            <Form.Item label="当前密码" name="old_password">
              <Input.Password placeholder="请输入当前的密码" defaultValue={old_password} onChange={(value) => { this.setState({ old_password: value.target.value }) }}></Input.Password>
            </Form.Item>


            <Form.Item label="新密码" name="new_password" tooltip={that.state.requiredMessage} rules={[
              { required: true, message: '请输入新密码!', },
              () => ({
                validator(_, value) {

                  if (that.verificatePassword(value)) {
                    return Promise.resolve();
                  }
                  else {
                    return Promise.reject(new Error(that.state.requiredMessage));
                  }
                },
              })
            ]} hasFeedback
            >
              <Input.Password placeholder="请输入新密码"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                onChange={(e) => this.setState({ new_password: e.target.value })}
              />
            </Form.Item>
            <Form.Item label="确认新密码" name="confirm"
              dependencies={['new_password']} hasFeedback
              rules={[
                { required: true, message: '请输入确认密码!', },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('new_password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('两次输入的密码不一致!'));
                  },
                }),
              ]} >
              <Input.Password placeholder="确认新密码" autoComplete="new-password" defaultValue={new_password} onChange={(value) => { this.setState({ new_password: value.target.value }) }}></Input.Password>
            </Form.Item>
          </Form>
        </WidgetModal>

      </div >
    );
  }
}

export default Login;
